import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as LinkIcon } from 'lucide-react';

interface ViewGoalLinkProps {
  link?: string;
}

export const ViewGoalLink: React.FC<ViewGoalLinkProps> = ({ link }) => {
  const { t } = useTranslation('goals');

  if (!link) {
    return null;
  }

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 flex items-center gap-2">
        <LinkIcon className="h-3.5 w-3.5" />
        {t('linkLabel')}
      </label>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-600 hover:bg-blue-100 transition-colors"
      >
        <LinkIcon className="h-4 w-4" />
        {link}
      </a>
    </div>
  );
};
